import { FormApplication } from './FormApplication'

export default FormApplication
